// extracted by mini-css-extract-plugin
export default {"backIcon":"AdminMobileEventRegister_backIcon__svD6y","regiBtn":"AdminMobileEventRegister_regiBtn__gMWyU"};